<div mat-dialog-title>
    {{'SCORE_PAGE.SPECIAL_TASK_DETAIL_DIALOG.TITLE' | translate}}
</div>
<div mat-dialog-content>
    <div *ngIf="(pageLoading$ | async)">
        <ngx-skeleton-loader 
            count="1" 
            appearance="line" 
            [theme]="{'margin-bottom': '2em','height':'147px'}">
        </ngx-skeleton-loader>
    </div>
    <div *ngIf="!(pageLoading$ | async)">
        <div *ngFor="let formItem of evaluationFormItems$ | async; index as i; count as count">
            <kt-evaluation-form-item
                [evaluationFormItem]="formItem"
                [evaluationFormGroup]="evaluationForm"
                [formAnswers]="savedFormAnswers$ | async"
                [maxLength]="maxInputLength"
                [maxCommentLength]="maxCommentLength"
                [exploreMode]="true"
                [protectedMode]="true"
                [showConversation]="false"
                [forceShowConversation]="false"
                [enableFileManager]="false">
            </kt-evaluation-form-item>    
            <mat-divider *ngIf="i < count-1" style="margin: 3em 0;"></mat-divider>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button 
        mat-raised-button color="primary"  class="btn-return"
        cdkFocusInitial
        (click)="dialogRef.close(false)">
        <i class="flaticon2-fast-back"></i>
        {{'SCORE_PAGE.SPECIAL_TASK_DETAIL_DIALOG.RETURN_BUTTON' | translate}}
    </button>
</div>